import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-web-style-top-bar',
    templateUrl: './web-style-top-bar.component.html',
    styleUrls: ['./web-style-top-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WebStyleTopBarComponent {
  @Input() pageTitle!: string;
}
